<template>
  <div
    class="container float-container"
    v-bind:class="{ active: value || focused || disabled }"
  >
    <label :for="'text-' + _uid" :class="{ error: _error }">{{ label }}</label>
    <input
      class="inputText"
      ref="input"
      :id="'text-' + _uid"
      :name="'text-' + _uid"
      type="search"
      :placeholder="cHint"
      :value="value"
      :class="{ error: _error, styleDisabled: disabled }"
      :pattern="pattern"
      :inputmode="inputmode"
      :maxlength="maxlength"
      :minlength="minlength"
      v-on:keypress="filter($event)"
      :disabled="disabled"
      @blur="onBlur"
      @focus="onFocus"
      @input="onInput"
      @click="$emit('click')"
      @paste="onPaste"
    />
    <span class="error" v-if="_error">
      <img src="@/assets/img/1x/error_icon.png" alt="error" />
      <p>{{ _error }}</p>
    </span>
    <span v-if="!_error && subhint" class="subhint">
      <p>{{ subhint }}</p>
    </span>
  </div>
</template>

<script>
export default {
  name: "text-input",
  props: {
    hint: String,
    label: String,
    value: String,
    name: String,
    pattern: String,
    inputmode: String,
    maxlength: String,
    minlength: String,
    subhint: String,
    validationError: String,
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      tmpHint: "",
      actualHint: this.hint,
      focused: false
    };
  },
  replace: false,
  computed: {
    cHint() {
      return this.tmpHint;
    },
    _error() {
      /**
       * Verificar si el componente padre
       * pasó un error de validación por props
       * si no --> usar el error interno
       */
      if (this.validationError) {
        return this.validationError;
      }
      return this.error;
    }
  },
  methods: {
    isNameOrLastname() {
      return this.name === "apellido" || this.name === "nombre";
    },
    isAlphabet(charCode) {
      return (
        (charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123)
      );
    },
    /* Si bien se usa Pattern y NumericInput, al no utilizar type="number" deja ingresar texto
    Pero si le pongo type="numeric", Me deja de funcionar el boton de clear de type="search", con lo cual
    tengo que filtrar el ingreso... bsternari */
    filter(evt) {
      // Validación al tipear solo si el componente es invocado en clientes (no empresas)
      if (this.isNameOrLastname()) {
        let in_chrs = "àáâãäçèéêëìíîïòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝ";

        let charCode = evt.which ? evt.which : evt.keyCode;
        if (
          this.isAlphabet(charCode) ||
          charCode == 8 ||
          charCode == 241 ||
          charCode == 209 ||
          charCode == 32 ||
          in_chrs.indexOf(evt.key) > -1
        ) {
          return true;
        } else {
          evt.preventDefault();
        }
      }
      if (this.inputmode !== "numeric") {
        return true;
      }

      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onInput(e) {
      // Función para reemplazar caracteres acentuados
      let stripAccents = (function() {
        let in_chrs = "àáâãäçèéêëìíîïòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝ",
          out_chrs = "aaaaaceeeeiiiiooooouuuuyyAAAAACEEEEIIIIOOOOOUUUUY",
          chars_rgx = new RegExp("[" + in_chrs + "]", "g"),
          transl = {},
          i,
          lookup = m => transl[m] || m;

        for (i = 0; i < in_chrs.length; i++) {
          transl[in_chrs[i]] = out_chrs[i];
        }

        return s => s.replace(chars_rgx, lookup);
      })();

      // No permitir caracteres acentuados
      e.target.value = stripAccents(e.target.value);
      this.$emit("input", e.target.value);
    },
    onPaste(evt) {
      // No permitir copy-paste si el texto a copiar tiene caracteres invalidos
      let letters = /^[a-zA-ZÀ-ÿ ']+(\s*[a-zA-ZÀ-ÿ ']+)*[a-zA-ZÀ-ÿ ']+$/;
      let pastedText = evt.clipboardData.getData("text");
      // Validación en el copy-paste solo si el componente es invocado en clientes (no empresas)
      if (this.name === "apellido" || this.name === "nombre") {
        if (!pastedText.match(letters)) {
          evt.preventDefault();
        }
      }
    },
    onBlur(e) {
      this.focused = false;
      this.$emit("onBlur");
      if (!e.target.value) {
        setTimeout(() => (this.tmpHint = ""), 180);
      }
    },
    onFocus() {
      this.focused = true;
      this.$emit("onFocus");
      setTimeout(() => (this.tmpHint = this.actualHint), 180);
    },
    _focus() {
      /* Forzar el foco en el elemento
      método útil para que usen elementos padres */
      this.$refs.input.focus();
    }
  }
};
</script>

<style scoped>
.inputText {
  /* Dar un poco de espacio para "centrar" el texto verticalmente */
  border-top: 17px solid transparent;
}

div.float-container {
  position: relative;
}

label {
  font-size: 15px;
  color: #666;
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
  position: absolute;
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-transform: translate(16px, 19px) scale(1);
  transform: translate(16px, 19px) scale(1);
  transition: all 0.3s ease-in-out;
}
div.float-container.active label {
  -webkit-transform: translate(16px, 8px) scale(0.75);
  transform: translate(16px, 8px) scale(0.75);
}

/* Estilos para campos deshabilitados */
input.styleDisabled {
  background: #acabab !important;
}

/* Estilos para errores */
input.error {
  background: #fcdfdf;
}

label.error {
  color: #b92a45;
}

span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}

/* Subhint */
span.subhint {
  display: block;
  padding-top: 5px;
}
</style>
